import React, { useEffect, useState } from "react";
import classes from "./header.module.css";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { AiOutlineMenu } from "@react-icons/all-files/ai/AiOutlineMenu";
import { AiOutlineClose } from "@react-icons/all-files/ai/AiOutlineClose";
import { MdAccountCircle } from "@react-icons/all-files/md/MdAccountCircle";
import { AiOutlineInfoCircle } from "@react-icons/all-files/ai/AiOutlineInfoCircle";
import { FcFeedback } from "@react-icons/all-files/fc/FcFeedback";
import { FaChevronDown } from "@react-icons/all-files/fa/FaChevronDown";
// @ts-ignore
import mergeClassNames from "merge-class-names";
import { GrLogout } from "@react-icons/all-files/gr/GrLogout";
import { FiUserPlus } from "@react-icons/all-files/fi/FiUserPlus";
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytesResumable,
} from "firebase/storage";
import emptyAvatar from "../../static/img/empty-avatar.png";
import ReactTooltip from "react-tooltip";
import { FiFilePlus } from "@react-icons/all-files/fi/FiFilePlus";
import { GiFiles } from "@react-icons/all-files/gi/GiFiles";
import { AiOutlineFileSearch } from "@react-icons/all-files/ai/AiOutlineFileSearch";
import { AiFillCalculator } from "@react-icons/all-files/ai/AiFillCalculator";
import { FaFile } from "@react-icons/all-files/fa/FaFile";
import { FaShoppingBag } from "@react-icons/all-files/fa/FaShoppingBag";
import SnowMan from "./SnowMan";
import { SHOW_CHRISTMAS_THEME } from "../../constant/constant";
import InstallAppBanner from "./InstallAppBanner";
import CustomNavLink from "../CustomNavLink";
import CustomLink from "../CustomLink";
import { SiConvertio } from "@react-icons/all-files/si/SiConvertio";
import { useUserSelector } from "../../redux/selector";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { changeAvatar, logout } from "../../redux/slices/authSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { FaGraduationCap } from "@react-icons/all-files/fa/FaGraduationCap";
import useRedirect from "../../hooks/useRedirect";
import { FiCheckSquare } from "@react-icons/all-files/fi/FiCheckSquare";
import {MdTopic} from "react-icons/md";
import {ImBlog} from "@react-icons/all-files/im/ImBlog";
import { HiOutlineDocument } from "@react-icons/all-files/hi/HiOutlineDocument";

function Header() {
  const [width, setWidth] = useState(window.innerWidth);
  const [openMenu, setOpenMenu] = useState(false);
  const inputFileRef = React.createRef<HTMLInputElement>();
  const user = useUserSelector();
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const redirect = useRedirect();

  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setOpenMenu(false);
  }, [location.pathname]);

  const handleLogout = () => {
    dispatch(logout())
      .then(unwrapResult)
      .then(() => {
        redirect("/", "Đăng xuất thành công!");
      })
      .catch((e) => {
        console.error(e);
        toast.error("Đăng xuất thất bại vui lòng thử lại nhé!");
      });
  };

  const handleOpenMenu = () => {
    setOpenMenu(true);
  };

  const handleCloseMenu = () => {
    setOpenMenu(false);
  };

  const activeItemClass = mergeClassNames(classes.menuItem, classes.active);
  const menuClasses = mergeClassNames(
    classes.mobileMenu,
    openMenu ? classes.open : ""
  );
  const redundantClass = mergeClassNames(
    classes.redundantButton,
    openMenu ? classes.open : ""
  );
  const rootClass = mergeClassNames(classes.root, openMenu ? classes.open : "");

  const handleSelectFile = () => {
    inputFileRef.current?.click();
  };

  const handleChooseFile = (e: any) => {
    if (!user) return;
    const file = e.target.files[0];
    if (
      file.type.split("/").length === 0 ||
      file.type.split("/")[0] !== "image"
    ) {
      alert("Vui lòng chọn file hình ảnh");
      return;
    }
    if (file.size > 1048576) {
      alert("Vui lòng chọn ảnh có kích thước dưới 1MB và tỉ lệ 1:1");
      return;
    }
    const fileName = (Math.random() + "").split(".")[1] + file.name;
    const storage = getStorage();
    const storageRef = ref(storage, "images/" + fileName);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      () => {},
      () => {},
      () => {
        getDownloadURL(uploadTask.snapshot.ref)
          .then((downloadURL) =>
            dispatch(changeAvatar(downloadURL)).then(unwrapResult)
          )
          .then(() => {
            toast.info("Cập nhật ảnh đại diện thành công!");
          })
          .catch((err) => {
            console.error(err);
            toast.error("Cập nhật ảnh đại diện thất bại");
          });
      }
    );
  };

  return (
    <div className={rootClass}>
      {SHOW_CHRISTMAS_THEME && <SnowMan />}
      <input
        type={"file"}
        onChange={handleChooseFile}
        ref={inputFileRef}
        className={classes.fileInput}
        accept={"image/gif, image/jpeg, image/png"}
      />
      <InstallAppBanner />
      
      {/* Mobile Menu */}
      {width <= 1024 && (
        <>
          <div className={redundantClass} onClick={handleCloseMenu}></div>
          <div className={menuClasses}>
            <div className={classes.mobileHeader}>
              <div className={classes.logoSection}>
                <h2 className={classes.mobileHeaderTitle}>Grade PTIT</h2>
                <p className={classes.mobileHeaderSubtitle}>Quản lý điểm thông minh</p>
              </div>
              <button className={classes.closeButton} onClick={handleCloseMenu}>
                <AiOutlineClose />
              </button>
            </div>
            
            <div className={classes.mobileContent}>
              <ul className={classes.accountSection}>
                {!user && (
                  <>
                    <li className={classes.mobileMenuItem}>
                      <CustomNavLink
                        to={"/login"}
                        className={(navData) =>
                          navData.isActive
                            ? mergeClassNames(
                                classes.mobileMenuItemContent,
                                classes.active
                              )
                            : classes.mobileMenuItemContent
                        }
                      >
                        <span className={classes.mobileIcon}>
                          <MdAccountCircle />
                        </span>
                        <span className={classes.mobileTitle}>Đăng nhập</span>
                      </CustomNavLink>
                    </li>
                    <li className={classes.mobileMenuItem}>
                      <CustomNavLink
                        to={"/register"}
                        className={(navData) =>
                          navData.isActive
                            ? mergeClassNames(
                                classes.mobileMenuItemContent,
                                classes.active
                              )
                            : classes.mobileMenuItemContent
                        }
                      >
                        <span className={classes.mobileIcon}>
                          <FiUserPlus />
                        </span>
                        <span className={classes.mobileTitle}>Đăng ký</span>
                      </CustomNavLink>
                    </li>
                  </>
                )}
                {user && (
                  <>
                    <li className={classes.userCard}>
                      <div className={classes.userCardContent}>
                        <span
                          className={classes.userAvatar}
                          onClick={handleSelectFile}
                          data-tip={
                            user.avatar
                              ? "Thay ảnh đại diện"
                              : "Thêm ảnh đại diện"
                          }
                        >
                          <img
                            className={classes.avatarImg}
                            alt={user.fullName.charAt(0)}
                            src={user.avatar || emptyAvatar}
                          />
                        </span>
                        <div className={classes.userDetails}>
                          <span className={classes.userName}>{user.fullName}</span>
                          <span className={classes.userCode}>{user.studentCode}</span>
                          <span className={classes.userEmail}>{user.email}</span>
                        </div>
                      </div>
                      <button className={classes.logoutBtn} onClick={handleLogout}>
                        <GrLogout />
                        <span>Đăng xuất</span>
                      </button>
                    </li>
                  </>
                )}
              </ul>
              
              <div className={classes.mobileNavSections}>
                <div className={classes.navSection}>
                  <h3 className={classes.navSectionTitle}>Tính năng chính</h3>
                  <ul className={classes.navList}>
                    <li className={classes.mobileMenuItem}>
                      <CustomNavLink
                        to={"/gpa-cpa-learning-plan"}
                        className={(navData) =>
                          navData.isActive
                            ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                            : classes.mobileMenuItemContent
                        }
                      >
                        <span className={classes.mobileIcon}>
                          <FaGraduationCap />
                        </span>
                        <span className={classes.mobileTitle}>GPA & CPA</span>
                      </CustomNavLink>
                    </li>
                    <li className={classes.mobileMenuItem}>
                      <CustomNavLink
                        to={"/practice-home"}
                        className={(navData) =>
                          navData.isActive
                            ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                            : classes.mobileMenuItemContent
                        }
                      >
                        <span className={classes.mobileIcon}>
                          <FiCheckSquare />
                        </span>
                        <span className={classes.mobileTitle}>Luyện thi trắc nghiệm</span>
                      </CustomNavLink>
                    </li>
                    <li className={classes.mobileMenuItem}>
                      <CustomNavLink
                        to={"/notes"}
                        className={(navData) =>
                          navData.isActive
                            ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                            : classes.mobileMenuItemContent
                        }
                      >
                        <span className={classes.mobileIcon}>
                          <HiOutlineDocument />
                        </span>
                        <span className={classes.mobileTitle}>Ghi chú học tập</span>
                      </CustomNavLink>
                    </li>
                    {user && (
                      <>
                        <li className={classes.mobileMenuItem}>
                          <CustomNavLink
                            to={"/file-list"}
                            className={(navData) =>
                              navData.isActive
                                ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                                : classes.mobileMenuItemContent
                            }
                          >
                            <span className={classes.mobileIcon}>
                              <GiFiles />
                            </span>
                            <span className={classes.mobileTitle}>Quản lý điểm PTIT</span>
                          </CustomNavLink>
                        </li>
                        <li className={classes.mobileMenuItem}>
                          <CustomNavLink
                            to={"/create-file"}
                            className={(navData) =>
                              navData.isActive
                                ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                                : classes.mobileMenuItemContent
                            }
                          >
                            <span className={classes.mobileIcon}>
                              <FiFilePlus />
                            </span>
                            <span className={classes.mobileTitle}>Tạo hồ sơ PTIT</span>
                          </CustomNavLink>
                        </li>
                        <li className={classes.mobileMenuItem}>
                          <CustomNavLink
                            to={"/find-file"}
                            className={(navData) =>
                              navData.isActive
                                ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                                : classes.mobileMenuItemContent
                            }
                          >
                            <span className={classes.mobileIcon}>
                              <AiOutlineFileSearch />
                            </span>
                            <span className={classes.mobileTitle}>Điểm của bạn bè</span>
                          </CustomNavLink>
                        </li>
                      </>
                    )}
                  </ul>
                </div>
                
                <div className={classes.navSection}>
                  <h3 className={classes.navSectionTitle}>Công cụ</h3>
                  <ul className={classes.navList}>
                    <li className={classes.mobileMenuItem}>
                      <CustomNavLink
                        to={"/calc-point"}
                        className={(navData) =>
                          navData.isActive
                            ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                            : classes.mobileMenuItemContent
                        }
                      >
                        <span className={classes.mobileIcon}>
                          <AiFillCalculator />
                        </span>
                        <span className={classes.mobileTitle}>Tính điểm tổng kết</span>
                      </CustomNavLink>
                    </li>
                    <li className={classes.mobileMenuItem}>
                      <CustomNavLink
                        to={"/convert-10-to-4"}
                        className={(navData) =>
                          navData.isActive
                            ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                            : classes.mobileMenuItemContent
                        }
                      >
                        <span className={classes.mobileIcon}>
                          <SiConvertio />
                        </span>
                        <span className={classes.mobileTitle}>Đổi điểm hệ 10 sang 4</span>
                      </CustomNavLink>
                    </li>
                    <li className={classes.mobileMenuItem}>
                      <CustomNavLink
                        to={"/file-view"}
                        className={(navData) =>
                          navData.isActive
                            ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                            : classes.mobileMenuItemContent
                        }
                      >
                        <span className={classes.mobileIcon}>
                          <FaFile />
                        </span>
                        <span className={classes.mobileTitle}>Hồ sơ điểm demo</span>
                      </CustomNavLink>
                    </li>
                  </ul>
                </div>
                
                <div className={classes.navSection}>
                  <h3 className={classes.navSectionTitle}>Khác</h3>
                  <ul className={classes.navList}>
                    <li className={classes.mobileMenuItem}>
                      <CustomNavLink
                        to={"/blog"}
                        className={(navData) =>
                          navData.isActive
                            ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                            : classes.mobileMenuItemContent
                        }
                      >
                        <span className={classes.mobileIcon}>
                          <ImBlog />
                        </span>
                        <span className={classes.mobileTitle}>Blog</span>
                      </CustomNavLink>
                    </li>
                    <li className={classes.mobileMenuItem}>
                      <CustomNavLink
                        to={"/do-dung-sinh-vien"}
                        className={(navData) =>
                          navData.isActive
                            ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                            : classes.mobileMenuItemContent
                        }
                      >
                        <span className={classes.mobileIcon}>
                          <FaShoppingBag />
                        </span>
                        <span className={classes.mobileTitle}>Đồ dùng sinh viên</span>
                      </CustomNavLink>
                    </li>
                    <li className={classes.mobileMenuItem}>
                      <CustomNavLink
                        to={"/about"}
                        className={(navData) =>
                          navData.isActive
                            ? mergeClassNames(classes.mobileMenuItemContent, classes.active)
                            : classes.mobileMenuItemContent
                        }
                      >
                        <span className={classes.mobileIcon}>
                          <AiOutlineInfoCircle />
                        </span>
                        <span className={classes.mobileTitle}>Giới thiệu</span>
                      </CustomNavLink>
                    </li>
                    <li className={classes.mobileMenuItem}>
                      <a
                        href={
                          "mailto:gradeptit@gmail.com?subject=Feedback to Gradeptit"
                        }
                        target={"_blank"}
                        rel={"noopener noreferrer"}
                        className={classes.mobileMenuItemContent}
                      >
                        <span className={classes.mobileIcon}>
                          <FcFeedback />
                        </span>
                        <span className={classes.mobileTitle}>Góp ý</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      
      {/* Desktop Header */}
      <div className={classes.container}>
        <div className={classes.left}>
          <CustomLink to={"/"} className={classes.logo}>
            <span className={classes.logoText}>Grade PTIT</span>
            <span className={classes.logoSubtext}>Quản lý điểm</span>
          </CustomLink>
        </div>
        
        {width < 1024 && (
          <div className={classes.menuButtonContainer}>
            <button className={classes.menuButton} onClick={handleOpenMenu}>
              <AiOutlineMenu />
            </button>
          </div>
        )}
        
        {width >= 1024 && (
          <nav className={classes.desktopNav}>
            <div className={classes.navLinks}>
              <CustomNavLink to={"/gpa-cpa-learning-plan"} className={classes.navLink}>
                GPA & CPA
              </CustomNavLink>
              <CustomNavLink to={"/practice-home"} className={classes.navLink}>
                Luyện tập
              </CustomNavLink>
              {user && (
                <CustomNavLink to={"/file-list"} className={classes.navLink}>
                  Quản lý điểm
                </CustomNavLink>
              )}
              <CustomNavLink to={"/blog"} className={classes.navLink}>
                Blog
              </CustomNavLink>
              <div className={classes.dropdown}>
                <button className={classes.dropdownBtn}>
                  <span>Thêm</span>
                  <FaChevronDown />
                </button>
                <div className={classes.dropdownContent}>
                  <div className={classes.dropdownSection}>
                    <h4 className={classes.dropdownSectionTitle}>Công cụ</h4>
                    <CustomNavLink to={"/calc-point"} className={classes.dropdownLink}>
                      <AiFillCalculator />
                      <span>Tính điểm tổng kết</span>
                    </CustomNavLink>
                    <CustomNavLink to={"/convert-10-to-4"} className={classes.dropdownLink}>
                      <SiConvertio />
                      <span>Đổi hệ điểm</span>
                    </CustomNavLink>
                    <CustomNavLink to={"/file-view"} className={classes.dropdownLink}>
                      <FaFile />
                      <span>Hồ sơ demo</span>
                    </CustomNavLink>
                    <CustomNavLink to={"/notes"} className={classes.dropdownLink}>
                      <HiOutlineDocument />
                      <span>Ghi chú học tập</span>
                    </CustomNavLink>
                  </div>
                  <div className={classes.dropdownSection}>
                    <h4 className={classes.dropdownSectionTitle}>Khác</h4>
                    <CustomNavLink to={"/do-dung-sinh-vien"} className={classes.dropdownLink}>
                      <FaShoppingBag />
                      <span>Đồ dùng sinh viên</span>
                    </CustomNavLink>
                    <CustomNavLink to={"/about"} className={classes.dropdownLink}>
                      <AiOutlineInfoCircle />
                      <span>Giới thiệu</span>
                    </CustomNavLink>
                    <a
                      href={"mailto:gradeptit@gmail.com?subject=Feedback to Gradeptit"}
                      target={"_blank"}
                      rel={"noopener noreferrer"}
                      className={classes.dropdownLink}
                    >
                      <FcFeedback />
                      <span>Góp ý</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            
            <div className={classes.authSection}>
              {user ? (
                <div className={classes.userDropdown}>
                  <div className={classes.userInfo}>
                    <div className={classes.userText}>
                      <span className={classes.userFullName}>{user.fullName}</span>
                      <span className={classes.userStudentCode}>{user.studentCode}</span>
                    </div>
                    <div className={classes.userAvatar}>
                      <img
                        className={classes.avatarImg}
                        alt={user.fullName.charAt(0)}
                        src={user.avatar || emptyAvatar}
                      />
                    </div>
                    <FaChevronDown className={classes.dropdownIcon} />
                  </div>
                  <div className={classes.userDropdownContent}>
                    <div className={classes.userDropdownHeader}>
                      <span
                        onClick={handleSelectFile}
                        className={classes.changeAvatarBtn}
                        data-tip={
                          user.avatar
                            ? "Thay ảnh đại diện"
                            : "Thêm ảnh đại diện"
                        }
                      >
                        <img
                          className={classes.avatarImg}
                          alt={user.fullName.charAt(0)}
                          src={user.avatar || emptyAvatar}
                        />
                      </span>
                      <div className={classes.userDropdownInfo}>
                        <span className={classes.dropdownUserName}>{user.fullName}</span>
                        <span className={classes.dropdownUserCode}>{user.studentCode}</span>
                        <span className={classes.dropdownUserEmail}>{user.email}</span>
                      </div>
                    </div>
                    <div className={classes.userDropdownActions}>
                      <button className={classes.logoutButton} onClick={handleLogout}>
                        <GrLogout />
                        <span>Đăng xuất</span>
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={classes.authButtons}>
                  <CustomLink to={"/login"} className={classes.loginBtn}>
                    Đăng nhập
                  </CustomLink>
                  <CustomLink to={"/register"} className={classes.registerBtn}>
                    Đăng ký
                  </CustomLink>
                </div>
              )}
            </div>
          </nav>
        )}
      </div>
      
      <ReactTooltip className={classes.tooltip} />
    </div>
  );
}

export default Header;
